import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import { PRESET_RATIO } from "./consts";
import type { AspectRatioElement, AspectRatioProps } from "./types";

function AspectRatio<E extends React.ElementType = AspectRatioElement>({
  as,
  asChild = false,
  presetRatio,
  className,
  ...props
}: AspectRatioProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Component
      className={cn(
        PRESET_RATIO[presetRatio as keyof typeof PRESET_RATIO],
        className,
        classes,
      )}
      {...native}
    />
  );
}
export default AspectRatio;
